<script setup lang="ts">
import {QBtn, useDialogPluginComponent} from 'quasar'
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import {ref, watch} from "vue";
import NamaIcon from "@/components/icons/NamaIcon.vue";

const props = defineProps({
  confirmationText: {type: String, required: true},
  title: {type: String, required: true},
  ok: {type: String, required: true},
  cancel: {type: String, required: true},
  isPersistent: {type: Boolean, required: true},
  alwaysLTR: {type: Boolean, required: false}
})
const okButton = ref<QBtn | undefined>();

defineEmits([
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits
])

const {compactMode} = storeToRefs(useNamaFlagsStore());

const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()

function onOKClick() {
  onDialogOK();
}

function onCancelClick() {
  onDialogCancel();
}

watch(() => okButton.value,
  (value) => {
    if (value)
      okButton.value?.$el.focus()
  }
)
</script>

<template>

  <q-dialog ref="dialogRef" @hide="onDialogHide" :persistent="isPersistent">
    <q-card class="tw-shadow-none dark:tw-bg-namaBackground-deep-dark tw-bg-namaBackground-deep-light !tw-rounded-none tw-min-w-[320px]">
      <q-bar v-if="title" class="tw-text-xs  tw-bg-primary-light tw-text-white   dark:tw-bg-[#212529] dark:tw-text-white tw-h-10"
             :dir="alwaysLTR?'ltr':undefined" >
        <div>{{ title }}</div>
        <q-space/>
        <q-btn dense flat @click="onDialogCancel" title="Close" class="nama-btn-hover nama-custom-btn focus:tw-bg-transparent">
          <q-avatar square class="tw-w-5">
            <NamaIcon default-icon="close" class="active-white"/>
          </q-avatar>
        </q-btn>
      </q-bar>
      <q-card-section v-html="confirmationText" class="tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal">
      </q-card-section>
      <q-card-section class="tw-flex tw-flex-row tw-gap-4 tw-justify-center">
        <q-btn
          ref="okButton"
          v-if="ok"
          :label="ok"
          outline
          @click="onOKClick"
          :dense="compactMode"
          class="tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-rounded-md tw-min-w-[90px]"/>
        <q-btn
          v-if="cancel"
          :label="cancel"
          :dense="compactMode"
          @click="onCancelClick"
          class="tw-bg-primary-light dark:tw-bg-primary-dark tw-text-white tw-text-base tw-font-normal tw-rounded-md tw-min-w-[90px]"/>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
